import { createSlice } from "@reduxjs/toolkit";

const now = new Date();
const today = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate()}`;
const d = {
    subAccountId: '',
    locationIds: [],
    from: today,
    to: today,
    riderCode: '',
    accountNo: '',
    weightRequired: false
};

const DarazLoadsheetSlice = createSlice({
    name: 'darazLoadSheetData',
    initialState: {
        data: d,
        locations: [],
        riders: [],
        grid: []
    },
    reducers: {
        setData: (state, action) => {
            state.data = action.payload.data
        },
        resetData: (state, action) => {
            state.data = d;
            state.setSelectedLocations = [];
        },
        setLocations: (state, action) => {
            state.locations = action.payload.data
        },
        setRiders: (state, action) => {
            state.riders = action.payload.data
        },
        setGrid: (state, action) => {
            state.grid = action.payload.data
        },
        updateGrid: (state, action) => {
            const index = action.payload.index;
            const key = action.payload.key;
            const val = action.payload.val;
            state.grid[index][key] = val;
        }
    }
});

export default DarazLoadsheetSlice.reducer;
export const { setData, resetData, setLocations, setRiders, setGrid, updateGrid } = DarazLoadsheetSlice.actions;